module.exports = __webpack_public_path__ + "static/media/4.593bb156.jpg";